import { render, staticRenderFns } from "./RewardDetails.vue?vue&type=template&id=6f89d54e&scoped=true"
import script from "./RewardDetails.vue?vue&type=script&lang=js"
export * from "./RewardDetails.vue?vue&type=script&lang=js"
import style0 from "./RewardDetails.vue?vue&type=style&index=0&id=6f89d54e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f89d54e",
  null
  
)

export default component.exports